/**
 * 超级管理员登录 - 参考 openlink.chat 设计风格
 */

import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
const apiClient = axios.create({ baseURL: '/api' });

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await apiClient.post('/admin/login', { username, password });
      if (res.data.success) {
        localStorage.setItem('admin_token', res.data.data.token);
        localStorage.setItem('admin_expires', res.data.data.expiresAt);
        navigate('/admin');
      } else {
        setError(res.data.error?.message || '登录失败');
      }
    } catch (err: any) {
      setError(err.response?.data?.error?.message || '网络错误');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 顶部导航栏 */}
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center space-x-2">
                <img src="/logo.png" alt="Logo" className="w-[90px] h-auto" />
              </Link>
              <span className="ml-3 text-sm text-gray-500">管理后台</span>
            </div>
          </div>
        </div>
      </nav>

      {/* 主内容 */}
      <main className="py-12">
        <div className="max-w-md mx-auto px-4">
          <div className="bg-white rounded-lg shadow-md p-8">
            <div className="text-center mb-6">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-lobster-red/10 mb-4">
                <svg className="w-8 h-8 text-lobster-red" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900">超级管理员登录</h2>
              <p className="text-gray-600 mt-2 text-sm">openbus.chat 管理平台</p>
            </div>

            <form onSubmit={handleLogin} className="space-y-4">
              {error && (
                <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
                  {error}
                </div>
              )}

              <div>
                <label className="block text-gray-700 text-sm font-medium mb-2">用户名</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full border border-gray-300 px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-lobster-red"
                  placeholder="请输入用户名"
                  autoComplete="username"
                />
              </div>

              <div>
                <label className="block text-gray-700 text-sm font-medium mb-2">密码</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full border border-gray-300 px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-lobster-red"
                  placeholder="请输入密码"
                  autoComplete="current-password"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-lobster-red text-white py-2 rounded-lg hover:bg-lobster-red/90 font-medium disabled:opacity-50"
              >
                {loading ? '登录中...' : '登录'}
              </button>
            </form>
          </div>
        </div>
      </main>

      {/* 页脚 */}
      <footer className="bg-white border-t mt-auto">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <img src="/logo.png" alt="Logo" className="w-6 h-6" />
              <span className="text-sm text-gray-600">OpenBus 管理后台</span>
            </div>
            <p className="text-sm text-gray-500">&copy; 2026 OpenBus. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
